(function () {
  'use strict'

  const ANAHTAR = 'olcu_birimi'
  const OLCU = /(\d+(?:[.,]\d+)?(?:\s*[×xX]\s*(?:[ØA-Za-zÇĞİÖŞÜçğıöşü]\s*)?\d+(?:[.,]\d+)?)*)(\s*)cm(?![A-Za-zÇĞİÖŞÜçğıöşü])/g
  const SAYI = /\d+(?:[.,]\d+)?/g

  function depoAl() {
    try {
      return sessionStorage.getItem(ANAHTAR)
    } catch (hata) {
      return null
    }
  }

  function depoYaz(deger) {
    try {
      sessionStorage.setItem(ANAHTAR, deger)
    } catch (hata) {
      return
    }
  }

  function inceCevir(metin) {
    const sayi = parseFloat(metin.replace(',', '.'))
    return String(Number((sayi / 2.54).toFixed(1)))
  }

  function metniCevir(metin) {
    return metin.replace(OLCU, (tum, dizi, bosluk) => dizi.replace(SAYI, inceCevir) + (bosluk || ' ') + 'in')
  }

  function alaniCevir(kok) {
    const gezgin = document.createTreeWalker(kok, NodeFilter.SHOW_TEXT, {
      acceptNode(dugum) {
        const ust = dugum.parentElement
        if (!ust || ust.closest('script, style, textarea, input, select, [data-olcu-haric]')) return NodeFilter.FILTER_REJECT
        return /\d\s*cm/.test(dugum.nodeValue) ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP
      }
    })
    const dugumler = []
    while (gezgin.nextNode()) dugumler.push(gezgin.currentNode)
    dugumler.forEach((dugum) => {
      const yeni = metniCevir(dugum.nodeValue)
      if (yeni !== dugum.nodeValue) dugum.nodeValue = yeni
    })
  }

  function ulkedenBirim(ulke) {
    return ulke && ulke.toUpperCase() !== 'TR' ? 'in' : 'cm'
  }

  async function birimBul() {
    const secim = new URLSearchParams(window.location.search).get('olcu')
    if (secim === 'in' || secim === 'cm') {
      depoYaz(secim)
      return secim
    }
    const kayitli = depoAl()
    if (kayitli === 'in' || kayitli === 'cm') return kayitli
    let ulke = ''
    const gezinme = performance.getEntriesByType('navigation')[0]
    const zamanlama = gezinme && gezinme.serverTiming ? gezinme.serverTiming.find((z) => z.name === 'country') : null
    if (zamanlama && zamanlama.description) ulke = zamanlama.description
    if (!ulke) {
      try {
        const kok = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/'
        const yanit = await fetch(kok + 'browsing_context_suggestions.json?country[enabled]=true', { headers: { Accept: 'application/json' } })
        const veri = await yanit.json()
        ulke = (veri.detected_values && veri.detected_values.country && veri.detected_values.country.handle) || ''
      } catch (hata) {
        ulke = ''
      }
    }
    if (!ulke) return 'cm'
    const birim = ulkedenBirim(ulke)
    depoYaz(birim)
    return birim
  }

  async function baslat() {
    const birim = await birimBul()
    if (birim !== 'in') return
    const ana = document.getElementById('MainContent')
    if (!ana) return
    alaniCevir(ana)
    let bekleyen = null
    new MutationObserver(() => {
      clearTimeout(bekleyen)
      bekleyen = setTimeout(() => alaniCevir(ana), 150)
    }).observe(ana, { childList: true, subtree: true })
  }

  baslat()
})()
